import { render, staticRenderFns } from "./Form19ProcessHeader.vue?vue&type=template&id=70c460ab&scoped=true"
import script from "./Form19ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form19ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form19ProcessHeader.vue?vue&type=style&index=0&id=70c460ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c460ab",
  null
  
)

export default component.exports